import { ActionList, ActionMenu } from "@primer/react";
import { ChevronDownIcon } from "@primer/octicons-react";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { truongApi } from "../../api/truongApi";
import { useCommonContext } from "../../contexts/common";
import { ITruong } from "../../models/response/truong/ITruong";
import { RootState } from "../../state/reducers";
import { useCommonSelectedHook } from "../../hooks/useCommonSelectedHook";

export type ComboboxTruongProps = {
  isReadonly?: boolean;
  disabled?: boolean;
  value?: number;
  onValueChanged: (id: number) => void;
  className?: string;
  isShowClearButton?: boolean;
  preText?: string;
  stylingMode?: "outlined" | "filled" | "underlined";
};
const ComboboxTruong = (props: ComboboxTruongProps) => {
  const [dm_truongs, setDmTruongs] = useState<ITruong[]>([]);
  const { translate } = useCommonContext();
  const { language } = useSelector((x: RootState) => x.common);
  const { dm_coso_id } = useCommonSelectedHook();
  const user_campus = useSelector((state: RootState) => state.auth.user_info?.campus);

  const handleReloadAsync = async () => {
    const res = await truongApi.selectAll();
    if (res.is_success) {
      let filteredData = res.data.filter(
        (truong: ITruong) => truong.dm_coso_id === dm_coso_id
      );
      if (user_campus && user_campus.length > 0) {
        const allowedIds = user_campus.map((c) => c.id);
        filteredData = filteredData.filter(
          (truong: ITruong) =>
            truong.id !== undefined && allowedIds.includes(truong.id)
        );
      }
      setDmTruongs(filteredData);
    }
  };

  useEffect(() => {
    handleReloadAsync();
  }, [dm_coso_id, user_campus]);

  const { value, onValueChanged } = props;

  const selectedData = useMemo(() => {
    if (value && dm_truongs) {
      const found = dm_truongs.find((x) => x.id === value);
      return found;
    }
    return undefined;
  }, [dm_truongs, value]);

  return (
    <div style={{ width: "100%" }}>
      <ActionMenu>
        <ActionMenu.Button
          disabled={props.disabled || props.isReadonly}
          aria-label="Select school year"
          className="button-left"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
          trailingAction={ChevronDownIcon}
        >
          {selectedData
            ? language === "en"
              ? selectedData.ten_truong_en
              : selectedData.ten_truong
            : translate("TruongCombobox.PlaceHolder")}
        </ActionMenu.Button>
        <ActionMenu.Overlay width="small">
          <ActionList selectionVariant="single">
            {props.isShowClearButton && (
              <ActionList.Item
                key={0}
                selected={value !== undefined && 0 === value}
                onSelect={() => {
                  onValueChanged(0);
                }}
              >
                {language === "en" ? "Select" : "Chọn cấp học"}
              </ActionList.Item>
            )}
            {dm_truongs &&
              dm_truongs.map((item) => {
                return (
                  <ActionList.Item
                    key={item.id}
                    selected={value !== undefined && item.id === value}
                    onSelect={() => {
                      onValueChanged(item.id || 0);
                    }}
                  >
                    {language === "en" ? item.ten_truong_en : item.ten_truong}
                  </ActionList.Item>
                );
              })}
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </div>
  );
};

export { ComboboxTruong };
